import { Injectable, inject } from '@angular/core';
import { ShiftTemplate } from '@wilson/interfaces';
import { ShiftTemplateService } from '@wilson/shift-templates';
import { catchError, ReplaySubject, tap } from 'rxjs';

@Injectable()
export class ShiftTemplateSelectService {
  private shiftTemplateService = inject(ShiftTemplateService);

  private shiftTemplateServiceCacheSubject = new ReplaySubject<ShiftTemplate[]>(
    1,
  );
  private hasCache = false;

  public getAllWithActivityTemplatesCached() {
    if (this.hasCache) {
      return this.shiftTemplateServiceCacheSubject.asObservable();
    } else {
      return this.shiftTemplateService
        .getAll({
          relations: [
            'shiftTemplateActivityTemplates',
            'shiftTemplateActivityTemplates.activityTemplate',
            'shiftTemplateActivityTemplates.activityTemplate.startLocation',
            'shiftTemplateActivityTemplates.activityTemplate.endLocation',
          ],
          limit: 0,
        })
        .pipe(
          tap((templates) => {
            this.shiftTemplateServiceCacheSubject.next(templates);
            this.hasCache = true;
          }),
          catchError(() => {
            return [];
          }),
        );
    }
  }
}
